import { render, staticRenderFns } from "./Reviewer.vue?vue&type=template&id=480a01ef"
import script from "./Reviewer.vue?vue&type=script&lang=js"
export * from "./Reviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports